import { render, staticRenderFns } from "./resourceVideo1.vue?vue&type=template&id=4cc950fd&scoped=true"
import script from "./resourceVideo1.vue?vue&type=script&lang=js"
export * from "./resourceVideo1.vue?vue&type=script&lang=js"
import style0 from "./resourceVideo1.vue?vue&type=style&index=0&id=4cc950fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc950fd",
  null
  
)

export default component.exports